import React from 'react';
import MainService from '../../services/MainService';
import TypeaheadInput from './TypeaheadInput';

const LocationAutocomplete = ({
  value,
  onChange,
  emirateId,
  placeholder = 'Search location...',
  disabled = false,
  required = false,
  label,
}) => {
  const isDisabled = disabled || !emirateId;

  return (
    <TypeaheadInput
      label={label}
      required={required}
      value={value}
      onChange={onChange}
      disabled={isDisabled}
      disabledPlaceholder="Select emirate first"
      placeholder={placeholder}
      emptyText="No locations found"
      fetchOptions={async (keyword) => {
        if (!emirateId) return [];
        return MainService.LocationsAutoCompleteByEmirate({
          Keyword: keyword,
          EmirateId: emirateId,
        });
      }}
    />
  );
};

export default LocationAutocomplete;
